import { withDefaults } from '@warp-drive/legacy/model/migration-support';
// Creator schema — referenced by ContentSource.creator relationship
import type { WithLegacy } from '@warp-drive/legacy/model/migration-support';
import type { Type } from '@warp-drive/core/types/symbols';

export type Creator = WithLegacy<{
  username: string | null;
  platform: string | null;
  displayName: string | null;
  accountUrl: string | null;
  avatarUrl: string | null;
  avatarPath: string | null;
  language: string | null;
  moderationStatus: string | null;
  banReason: string | null;
  firstSeenAt: string | null;
  lastSeenAt: string | null;
  createdAt: string | null;
  updatedAt: string | null;
  [Type]: 'creators';
}>;

export const CreatorSchema = withDefaults({
  type: 'creators',
  fields: [
    { name: 'username', kind: 'attribute', type: 'string' },
    { name: 'platform', kind: 'attribute', type: 'string' },
    { name: 'displayName', kind: 'attribute', type: 'string' },
    { name: 'accountUrl', kind: 'attribute', type: 'string' },
    { name: 'avatarUrl', kind: 'attribute', type: 'string' },
    { name: 'avatarPath', kind: 'attribute', type: 'string' },
    { name: 'language', kind: 'attribute', type: 'string' },
    { name: 'moderationStatus', kind: 'attribute', type: 'string' },
    { name: 'banReason', kind: 'attribute', type: 'string' },
    { name: 'firstSeenAt', kind: 'attribute', type: 'string' },
    { name: 'lastSeenAt', kind: 'attribute', type: 'string' },
    { name: 'createdAt', kind: 'attribute', type: 'string' },
    { name: 'updatedAt', kind: 'attribute', type: 'string' },
    {
      name: 'contentSources',
      kind: 'hasMany',
      type: 'content-sources',
      options: { async: true, inverse: null },
    },
  ],
});
